import React, { useState, useImperativeHandle } from 'react';
import { Divider, Radio } from '../index';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import './index.less';
const defaultClipperItem = {
    key: 'custom',
    title: '自定义',
    initialAspectRatio: 1,
    description: '自定义裁剪预览',
};
const defaultStyle = { width: '100%' };
const ImageClipper = React.forwardRef((props, ref) => {
    const { clipperTitle = '裁剪区域', previewTitle = '预览区域', dragMode = 'move', guides = false, clipperStyle = {}, viewMode = 1, zoomable = true, rotatable = true, responsive = true, checkCrossOrigin = true, clipperItems, imageSrc, maxImageHeight = 500, crop, cropend, } = props;
    const cropRefs = React.useRef({});
    const thisRef = React.useRef(null);
    let standardClipperItems = [];
    if (clipperItems) {
        standardClipperItems = standardClipperItems.concat(clipperItems);
    }
    else {
        standardClipperItems = [defaultClipperItem];
    }
    const [currentClipperItem, setCurrentClipperItem] = useState(standardClipperItems[0]);
    const onAspectRatioChange = (e) => {
        setCurrentClipperItem(e.target.value);
    };
    const onReady = (e, item) => {
        if (maxImageHeight && !clipperStyle.height) {
            for (let key of Object.keys(cropRefs.current)) {
                cropRefs.current[key].img.parentElement.style.height = maxImageHeight + 'px';
            }
            window.dispatchEvent(new Event('resize'));
        }
        onCropend(e, item);
    };
    const onCropend = (e, item) => {
        if (cropend) {
            cropend(e, item, e.currentTarget.cropper.getCroppedCanvas().toDataURL());
        }
    };
    const onCrop = (e, item) => {
        if (crop) {
            crop(e, item);
        }
    };
    useImperativeHandle(ref, () => ({
        getClipperImage: () => {
            return standardClipperItems.map((item) => {
                return {
                    key: item.key,
                    image: cropRefs.current[item.key].getCroppedCanvas().toDataURL(),
                };
            });
        },
    }));
    return (<div className="image-clipper" ref={thisRef}>
            <div className="clipper-zone">
                <h3>{clipperTitle}</h3>
                <div className="content">
                    {standardClipperItems.map((item) => (<div key={item.key} className="clipper" 
        // 要在隐藏时还能获取到clipper的高度
        style={{
                visibility: currentClipperItem.key === item.key ? 'visible' : 'hidden',
                position: currentClipperItem.key === item.key ? 'relative' : 'absolute',
            }}>
                            <Cropper ref={(el) => {
                cropRefs.current[item.key] = el;
            }} src={imageSrc} style={Object.assign({}, defaultStyle, clipperStyle)} initialAspectRatio={item.initialAspectRatio} aspectRatio={item.aspectRatio} guides={guides} viewMode={viewMode} zoomable={zoomable} rotatable={rotatable} checkCrossOrigin={checkCrossOrigin} preview={`.img-preview-${item.key}`} dragMode={dragMode} crop={(e) => onCrop(e, item)} responsive={responsive} restore={false} cropend={(e) => onCropend(e, item)} ready={(e) => onReady(e, item)}/>
                        </div>))}
                </div>
                <div className="aspect-ratio-bar">
                    <Radio.Group onChange={onAspectRatioChange} defaultValue={currentClipperItem}>
                        {standardClipperItems.length > 1 &&
            standardClipperItems.map((item) => (<Radio.Button key={item.key} value={item}>
                                    {item.aspectRatioTitle}
                                </Radio.Button>))}
                    </Radio.Group>
                </div>
            </div>
            <Divider type="vertical" className="divider"/>
            <div className="preview-zone">
                <h3>{previewTitle}</h3>
                <div className="content">
                    {standardClipperItems.map((item) => (<div key={item.key} className="preview-clipper-item">
                            <div className={`img-preview-${item.key}`} style={{
                width: '200px',
                height: `${200 / (item.aspectRatio || 1)}px`,
                minWidth: '200px',
                minHeight: `${200 / (item.aspectRatio || 1)}px`,
            }}/>
                            <div className="clipper-item-content">
                                <h4 className="title">
                                    {item.title}
                                    {item.aspectRatioTitle && ` (${item.aspectRatioTitle})`}
                                </h4>
                                <div className="description">{item.description}</div>
                            </div>
                        </div>))}
                </div>
            </div>
        </div>);
});
export default ImageClipper;
